import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type CreateCategoryDimensionPayload = {
	itemCategoryId: string;
	weight: number;
	isTextbox: boolean;
	sequence: number;
	isPublicRequired: boolean;
	isBackofficeRequired: boolean;
	localizations: {
		"en-us": string;
		"de-ch": string;
		"de-de": string;
		"fr-fr": string;
		"it-it": string;
	};
};

const createCategoryDimension = async (payload: CreateCategoryDimensionPayload): Promise<any> => {
	const response = await apiDal.post("/categorydimension/create", payload);
	return response.data;
};

export const useCreateCategoryDimension = () => {
	return useMutation({
		mutationFn: createCategoryDimension,
	});
};
